import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/global/newlink.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"40px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"100%"},
    alt: "能链企服"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "能链NewLink，能源变革推动者，能源物联网EIoT及能源新零售平台。国内外双料独角兽，全球新能源500强，员工超过3000人。覆盖油、电、氢、气多能源品类，打通能源产业链上下游，数字化重构能源生态。业务覆盖1800城，旗下有能链团油、能链快电、能链云、能链直供、能链综合能源港、能链智电六大产品。", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "自2016年成立以来，能链集团已累计完成数十亿元融资，屡创数字能源领域的融资纪录，投资方包括贝恩资本、愉悦资本、中金资本、中小企业发展基金、小米集团、蔚来资本、KIP中国等。", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "能链企服是能链集团旗下的一款产品， 围绕企业能源补给，实现人、财、物数字化管理。", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "能链企服深刻洞察企业燃油管理难题、破解企业燃油管理困局，助力企业能源管理实现降本、提效、规范的目的。", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-top":"30px"} }, [
  /*#__PURE__*/_createElementVNode("h2", null, "联系我们"),
  /*#__PURE__*/_createElementVNode("p", null, "客服电话： 400-0063-888"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("网站："),
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.newlink.com" }, "www.newlink.com")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "地址：北京市朝阳区姚家园南路1号汇通时代广场7号楼G区 能链中心")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer aboutUs" }, {
    title: _withCtx(() => [
      _createVNode(_component_router_link, {
        class: "link-goback",
        to: {name: 'profile.info'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_icon, { type: "arrow-left" })
        ]),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(" 关于我们 ")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6
    ]),
    _: 1
  }))
}